import { getTranslatedMessages } from './translates';

$('.contact-form').validate({
    rules: {
        name: {
            required: true,
        },
        email: {
            required: true,
            email: true,
        },
        message: {
            required: true,
        },
        contact_subject_id: {
            required: true,
        },
    },
    messages: getTranslatedMessages(),
});
